import { HealthcareBasicData } from '../../../common/HealthcareBasicData';

import { HealthcareFacilityTreeItem } from './HealthcareFacilityTreeItem';
import { HealthcareFacilityTreeItemsLoader } from './HealthcareFacilityTreeItems.loader';

type HealthcareFacilityTreeItemsProps = {
   readonly healthcareParentData: HealthcareBasicData;
};

export const HealthcareFacilityTreeItems = (props: HealthcareFacilityTreeItemsProps): JSX.Element => {
   return (
      <HealthcareFacilityTreeItemsLoader healthcareParentData={props.healthcareParentData}>
         {({ healthcareFacilities, refetchHealthcareFacilities }) => (
            <>
               {healthcareFacilities.map((healthcareFacility) => (
                  <HealthcareFacilityTreeItem
                     key={healthcareFacility.id}
                     healthcareFacility={healthcareFacility}
                     healthcareParentData={props.healthcareParentData}
                     onDataChanged={refetchHealthcareFacilities}
                  />
               ))}
            </>
         )}
      </HealthcareFacilityTreeItemsLoader>
   );
};
